<section class="flex flex-col gap-6">
  <app-admin-page-header
    eyebrow="Contenu"
    title="Actualités"
    subtitle="Articles publiés sur le site, visibles par tous les visiteurs.">
    <button (click)="openModal()" type="button"
      class="inline-flex items-center gap-2 px-4 py-2 bg-primary text-white text-sm font-raleway font-semibold rounded-lg hover:bg-secondary transition-colors shadow-sm">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14m-7-7v14"/>
      </svg>
      Ajouter une actualité
    </button>
  </app-admin-page-header>

  <!-- Liste des actualités -->
  <div class="bg-white rounded-xl border border-gray-200 shadow-sm">
    <div class="px-5 py-4 border-b border-gray-100 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <div class="relative w-full max-w-md">
        <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
          </svg>
        </div>
        <input type="search" [(ngModel)]="search" placeholder="Rechercher par titre ou auteur..."
          class="w-full pl-10 pr-3 py-2 text-sm font-raleway bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary">
        </div>
        <p class="text-xs text-gray-500 font-raleway">{{ filteredActualites.length }} article{{ filteredActualites.length > 1 ? 's' : '' }}</p>
      </div>
      <div class="min-w-full">
        <table class="w-full text-sm text-left text-gray-500 font-raleway">
          <tbody class="divide-y divide-gray-100">
            @for (actualite of filteredActualites; track actualite) {
              <tr class="hover:bg-gray-50 transition-colors">
                <td class="px-5 py-4">
                  <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-3">
                    <div class="flex items-center gap-3 min-w-0">
                      <div class="w-12 h-12 rounded-lg bg-gradient-to-br from-purple-100 to-purple-200 flex items-center justify-center shrink-0 overflow-hidden">
                        @if (actualite.image) {
                          <img [src]="actualite.image" alt="" class="w-full h-full object-cover">
                        } @else {
                          <svg class="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"/></svg>
                        }
                      </div>
                      <div class="min-w-0">
                        <p class="font-raleway font-semibold text-gray-800 truncate flex items-center gap-2">
                          {{ actualite.titre }}
                          @if (actualite.statut === 'brouillon') {
                            <span class="shrink-0 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide bg-amber-100 text-amber-700 rounded-full">Brouillon</span>
                          }
                        </p>
                        <p class="text-xs text-gray-500 truncate font-raleway">
                          {{ formatDate(actualite.date) }}@if (actualite.auteur) {
                          <span> · {{ actualite.auteur }}</span>
                        }
                      </p>
                    </div>
                  </div>
                  <div class="flex gap-2 justify-end">
                    <div class="relative">
                      <button type="button" [id]="'dropdownButton-desktop-' + (actualite.key ?? '')" (click)="toggleDropdown(actualite.key ?? '', false)" class="text-gray-700 border border-gray-300 bg-white hover:bg-gray-100 focus:ring-1 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 inline-flex items-center relative">
                        Actions
                        <svg class="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
                        </svg>
                      </button>
                      <div [id]="'dropdown-desktop-' + (actualite.key ?? '')" class="z-[9999] hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 absolute mt-2" style="right: 0;">
                        <ul class="py-2 text-sm text-gray-700" [attr.aria-labelledby]="'dropdownButton-desktop-' + (actualite.key ?? '')">
                          <li>
                            <a href="/actualites/{{ actualite.key }}" target="_blank" class="flex items-center px-4 py-2 hover:bg-gray-100">
                              <svg class="w-4 h-4 mr-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
                              </svg>
                              Consulter
                            </a>
                          </li>
                          <li>
                            <button (click)="onEdit(actualite)" class="flex items-center w-full px-4 py-2 hover:bg-gray-100">
                              <svg class="w-4 h-4 mr-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m14.3 4.8 2.9 2.9M7 7H4a1 1 0 0 0-1 1v10c0 .6.4 1 1 1h11c.6 0 1-.4 1-1v-4.5m2.4-10a2 2 0 0 1 0 3l-6.8 6.8L8 14l.7-3.6 6.8-6.8a2 2 0 0 1 2.9 0Z"/>
                              </svg>
                              Modifier
                            </button>
                          </li>
                          <li>
                            <button (click)="onDelete(actualite)" class="flex items-center w-full px-4 py-2 hover:bg-red-50 text-red-600">
                              <svg class="w-4 h-4 mr-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"/>
                              </svg>
                              Supprimer
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          }
          @if (filteredActualites.length === 0) {
            <tr>
              <td class="px-5 py-12 text-center text-sm text-gray-400 font-raleway">
                @if (search) {
                  <span>Aucune actualité ne correspond à « {{ search }} ».</span>
                }
                @if (!search) {
                  <span>Aucune actualité publiée.</span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <!-- Modal -->
  <div [id]="'actualiteModal'" [class.hidden]="!isModalOpen" class="fixed inset-0 z-50 overflow-y-auto">
    <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <!-- Background overlay -->
      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <!-- Modal panel -->
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="flex justify-between items-center mb-4">
            <h3 class="text-lg font-medium leading-6 text-gray-900">{{ actualite ? 'Modifier' : 'Ajouter' }} une actualité</h3>
            <button (click)="closeModal()" type="button" class="text-gray-400 hover:text-gray-500">
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div #editSection>
            <form [formGroup]="actualiteForm" (ngSubmit)="onSubmit()">
              <div class="space-y-6">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div class="col-span-1 md:col-span-2">
                    <label for="titre" class="block text-sm font-semibold text-gray-700 font-raleway">Titre</label>
                    <input type="text" id="titre" formControlName="titre"
                      class="mt-1 block w-full px-3 py-2 bg-transparent border border-gray-300 rounded-md text-sm shadow-sm placeholder-gray-400 font-raleway
                      focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
                  </div>

                  <div class="col-span-1 md:col-span-2">
                    <label for="contenu" class="block text-sm font-semibold text-gray-700 font-raleway">Contenu</label>
                    <quill-editor #editor
                      formControlName="contenu"
                      [modules]="modules"
                      class="h-[500px] bg-white w-full">
                    </quill-editor>
                    <p class="mt-2 text-sm text-gray-500">
                      Astuce : Sélectionnez une image pour afficher les options d'alignement
                    </p>
                  </div>

                  <div class="col-span-1">
                    <label for="date" class="block text-sm font-semibold text-gray-700 font-raleway">Date de publication</label>
                    <input type="date" id="date" formControlName="date"
                      class="mt-1 block w-full px-3 py-2 bg-transparent border border-gray-300 rounded-md text-sm shadow-sm placeholder-gray-400 font-raleway
                      focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
                  </div>

                  <div class="col-span-1">
                    <label for="auteur" class="block text-sm font-semibold text-gray-700 font-raleway">Auteur</label>
                    <input type="text" id="auteur" formControlName="auteur"
                      class="mt-1 block w-full px-3 py-2 bg-transparent border border-gray-300 rounded-md text-sm shadow-sm placeholder-gray-400 font-raleway
                      focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
                  </div>

                  <div class="col-span-1 md:col-span-2">
                    <label class="block text-sm font-semibold text-gray-700 font-raleway">Statut</label>
                    <div class="mt-1 flex gap-2">
                      <button type="button" (click)="actualiteForm.patchValue({statut: 'publie'})"
                        [class.bg-primary]="actualiteForm.get('statut')?.value === 'publie'"
                        [class.text-white]="actualiteForm.get('statut')?.value === 'publie'"
                        [class.bg-gray-100]="actualiteForm.get('statut')?.value !== 'publie'"
                        [class.text-gray-600]="actualiteForm.get('statut')?.value !== 'publie'"
                        class="px-3 py-1.5 rounded-full text-sm font-raleway font-medium transition-colors">
                        Publié
                      </button>
                      <button type="button" (click)="actualiteForm.patchValue({statut: 'brouillon'})"
                        [class.bg-amber-500]="actualiteForm.get('statut')?.value === 'brouillon'"
                        [class.text-white]="actualiteForm.get('statut')?.value === 'brouillon'"
                        [class.bg-gray-100]="actualiteForm.get('statut')?.value !== 'brouillon'"
                        [class.text-gray-600]="actualiteForm.get('statut')?.value !== 'brouillon'"
                        class="px-3 py-1.5 rounded-full text-sm font-raleway font-medium transition-colors">
                        Brouillon
                      </button>
                    </div>
                    <p class="mt-1 text-xs text-gray-500">Un brouillon n'est visible que par les administrateurs, y compris via son lien direct.</p>
                  </div>

                  <div class="col-span-1 md:col-span-2">
                    <label class="block text-sm font-semibold text-gray-700 font-raleway">Image</label>
                    <div class="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-lg">
                      <div class="space-y-1 text-center">
                        <svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48">
                          <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <div class="flex text-sm text-gray-600">
                          <label for="file-upload" class="relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-blue-500">
                            <span>Télécharger une image</span>
                            <input id="file-upload" name="file-upload" type="file" class="sr-only" (change)="onImageSelected($event)" accept="image/*">
                          </label>
                          <p class="pl-1">ou glisser-déposer</p>
                        </div>
                        <p class="text-xs text-gray-500">PNG, JPG, GIF jusqu'à 10MB</p>
                      </div>
                    </div>
                    @if(actualiteForm.get('imagePreview')?.value || actualite?.image) {
                      <div class="mt-2">
                        <img [src]="actualiteForm.get('imagePreview')?.value || actualite?.image"
                          alt="Prévisualisation"
                          class="h-32 w-32 object-cover rounded">
                      </div>
                    }
                  </div>

                  <div class="col-span-1 md:col-span-2">
                    <label class="block text-sm font-semibold text-gray-700 font-raleway">Tags</label>
                    <div class="mt-2 flex flex-wrap gap-2">
                      @for(tagType of tagTypes; track tagType) {
                        <button
                          type="button"
                          (click)="toggleTag(tagType)"
                          [class.opacity-40]="!isTagSelected(tagType)"
                          class="px-3 py-1 text-sm rounded-full text-white transition-opacity duration-200"
                          [style.background-color]="tagConfig[tagType].color">
                          {{ tagConfig[tagType].label }}
                        </button>
                      }
                    </div>
                  </div>
                </div>

                <div class="flex flex-col gap-4 sm:flex-row pt-4">
                  <button type="button" (click)="openPreview()"
                    class="w-full bg-white text-gray-700 px-6 py-3 rounded-md text-sm font-medium border-2 border-gray-300 font-raleway
                    hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 transition-colors">
                    Prévisualiser
                  </button>
                  <button type="submit"
                    class="w-full bg-blue-600 text-white px-6 py-3 rounded-md text-sm font-medium hover:bg-blue-700 font-raleway
                    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors">
                    Enregistrer
                  </button>
                  <button type="button" (click)="closeModal()"
                    class="w-full bg-transparent text-red-600 px-6 py-3 rounded-md text-sm font-medium border-2 border-red-600 font-raleway
                    hover:bg-red-600 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors">
                    Annuler
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Preview Modal -->
  <div [class.hidden]="!isPreviewOpen" class="fixed inset-0 z-[60] overflow-y-auto bg-white">
    <div class="sticky top-0 z-10 bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between">
      <div>
        <p class="text-xs uppercase tracking-wide text-gray-400 font-raleway">Aperçu</p>
        <p class="text-sm text-gray-600 font-raleway">Rendu tel qu'il apparaîtra sur le site (non enregistré)</p>
      </div>
      <button (click)="closePreview()" type="button" class="text-gray-400 hover:text-gray-600">
        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    @if (isPreviewOpen) {
      <article class="container py-8">
        <app-actualite-content [actualite]="previewActualite"></app-actualite-content>
      </article>
    }
  </div>

  <!-- Delete Confirmation Modal -->
  <div [id]="'deleteModal'" [class.hidden]="!isDeleteModalOpen" class="fixed inset-0 z-50 overflow-y-auto">
    <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <!-- Background overlay -->
      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <!-- Modal panel -->
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
              <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                Supprimer l'actualité
              </h3>
              <div class="mt-2">
                <p class="text-sm text-gray-500">
                  Êtes-vous sûr de vouloir supprimer l'actualité "{{ actualiteToDelete?.titre }}" ? Cette action est irréversible.
                </p>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button type="button" (click)="confirmDelete()"
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
              Supprimer
            </button>
            <button type="button" (click)="closeDeleteModal()"
              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:w-auto sm:text-sm">
              Annuler
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Update le form. -->